import { rest } from 'msw'
const data = require('../data/dataset.json')

export default [
  /**
   * トレンドグラフ取得API
   */
  rest.get('/swc-api/datasets/:id', (req, res, ctx) => {
    const key = req.params.id
    return res(
      ctx.status(200),
      ctx.json(data[key]),
    )
  }),
]
